// extracted by mini-css-extract-plugin
export default {"container":"DisplayRecommendation_container__hVgDq","text":"DisplayRecommendation_text__bYM+l","buttonContainer":"DisplayRecommendation_buttonContainer__h7Huz"};